export type LoadExternalScriptOptions = {
  id: string;
  src: string;
};

export type LoadExternalScriptResult =
  | {
      status: 'loaded';
      element: HTMLScriptElement;
    }
  | {
      status: 'already-exists';
      element: HTMLScriptElement;
    };

export const loadExternalScript = ({ id, src }: LoadExternalScriptOptions) => {
  return new Promise<LoadExternalScriptResult>((resolve, reject) => {
    if (typeof document === 'undefined') {
      reject(new Error('Document is not available.'));
      return;
    }

    const existingScript = document.getElementById(id);
    if (existingScript instanceof HTMLScriptElement) {
      resolve({
        status: 'already-exists',
        element: existingScript,
      });
      return;
    }

    const target = document.body ?? document.head;
    if (!target) {
      reject(new Error('Document body is not available.'));
      return;
    }

    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.type = 'text/javascript';

    script.onload = () => {
      resolve({
        status: 'loaded',
        element: script,
      });
    };

    script.onerror = () => {
      script.remove();
      reject(new Error(`Failed to load script with src ${src}.`));
    };

    target.appendChild(script);
  });
};
